import styled from "styled-components";
import { Github } from "@styled-icons/boxicons-logos/Github";
import { LinkedinSquare } from "@styled-icons/boxicons-logos/LinkedinSquare";
import { Mail } from "@styled-icons/entypo/Mail";
// import { Medium } from "@styled-icons/boxicons-logos/Medium";
import { Rocket } from "@styled-icons/ionicons-outline/Rocket";
import { FilePdf } from "@styled-icons/boxicons-solid/FilePdf";
import Section from "../Section";
import Header from "../Header";

const text = {
  header: `Ladi Bello`,
  subHeading: "I build Software and High-Performing Teams ",
};

const emailLink = "mailto:davybello51@gmail.com";
const social = [
  {
    name: "email",
    link: emailLink,
    icon: Mail,
  },
  {
    name: "linked in",
    link: "https://www.linkedin.com/in/oladipupo-bello-755897152",
    icon: LinkedinSquare,
  },
  {
    name: "github",
    link: "https://github.com/DavyBello",
    icon: Github,
  },
  {
    name: "resume",
    link: "/resume/resume.pdf",
    icon: FilePdf,
  },
];

const Wrapper = styled.div`
  width: 100%;
  text-align: center;
`;

const CRocket = styled.svg`
  width: 20px;
  color: rgb(80, 230, 255);
`;

const Icon = styled.i`
  width: 30px;
  transition: all 300ms ease-out 0s;

  :hover {
    opacity: 1;
    transform: translateY(-4px);
    border-width: initial;
    border-style: none;
    border-color: initial;
    border-image: initial;
    outline: none;
  }
`;

const Image = styled.img`
  border-radius: 50%;
  max-width: 230px;
  border-style: solid;
`;

const SocialLink = styled.a.attrs({
  className: "mx-2",
})`
  color: white;
`;

const HeroSection = () => (
  <Section backgroundColor="#243b5e" height="100vh">
    <div className="title-text">
      <Wrapper>
        <div className="img-container flex flex-wrap gap-2">
          <Image src="/profile.png" />
        </div>
        <Header>{text.header}</Header>
        <p style={{ color: "#9fadc2" }}>{text.subHeading} <CRocket as={Rocket}/></p>
        <div className="mt-5 pt-5">
          {social.map(({ link, icon }, i) => (
            <SocialLink key={i} href={link} target="_blank" rel="noopener">
              <Icon as={icon} />
            </SocialLink>
          ))}
        </div>
      </Wrapper>
    </div>
    <style>{`
            .title-text {
                display: flex;
                align-items: center;
                color: rgb(80, 230, 255);
                height: 100%;
            }
        `}</style>
  </Section>
);

export default HeroSection;
